import { createTheme, ThemeProvider } from '@mui/material/styles';
import useThemeToggle from './UseThemeToggle.hook';
import { DispatchThemeOptions } from './dispatch-theme/DispatchThemeOptions';
export function useDispatchTheme() {
  const { isDark, toggle } = useThemeToggle();
  const dispatchTheme = createTheme(DispatchThemeOptions);
  return {
    ThemeProvider,
    theme: dispatchTheme,
    isDark,
    toggleDarkMode: toggle,
  };
}
